import { render, staticRenderFns } from "./ResumeQuotations.vue?vue&type=template&id=4da6d530&scoped=true&lang=pug"
import script from "./ResumeQuotations.vue?vue&type=script&lang=js"
export * from "./ResumeQuotations.vue?vue&type=script&lang=js"
import style0 from "./ResumeQuotations.vue?vue&type=style&index=0&id=4da6d530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6d530",
  null
  
)

export default component.exports